import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"; // about
import AccountTreeRoundedIcon from "@material-ui/icons/AccountTreeRounded";
import PermContactCalendarRoundedIcon from "@material-ui/icons/PermContactCalendarRounded";
import { IconButton } from "@material-ui/core";

const Header = () => {
  const [mobileView, setMobileView] = useState(window.innerWidth);

  const handleToggle = () => {
    setMobileView(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleToggle);
    return () => {
      window.removeEventListener("resize", handleToggle);
    };
  }, []);

  return (
    <header className="header">
      <div className="navigation">
        <Link to="/" className="content">
          <HomeOutlinedIcon
            className={`${mobileView < 768 ? "mobile" : "desktop"}`}
          />
          {mobileView > 768 && <h2>Home</h2>}
        </Link>
        <Link to="/about" className="content">
          <InfoOutlinedIcon
            className={`${mobileView < 768 ? "mobile" : "desktop"}`}
          />
          {mobileView > 768 && <h2>About</h2>}
        </Link>
        <Link to="/projects" className="content">
          <AccountTreeRoundedIcon
            className={`${mobileView < 768 ? "mobile" : "desktop"}`}
          />
          {mobileView > 768 && <h2>Projects</h2>}
        </Link>
        <Link to="/contact" className="content">
          <PermContactCalendarRoundedIcon
            className={`${mobileView < 768 ? "mobile" : "desktop"}`}
          />
          {mobileView > 768 && <h2>Contact</h2>}
        </Link>
      </div>
    </header>
  );
};

export default Header;
